module.exports = __webpack_public_path__ + "fonts/Inter-500-latin-ext55.ad4eb06.woff2";